import styled from '@emotion/styled';
import { ActionMenu, Text, tokens } from '@hotjar/hotsauce';

export const Line = styled.li`
  width: 100%;
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2pt5};
  background-color: ${tokens.color.white};

  display: flex;
  justify-content: center;

  border-bottom: 1px solid ${tokens.color.neutral_300};
`;

export const ErrorActionMenu = styled(ActionMenu)`
  background-color: white;
  // @TODO Find a DS color for the border. #b5b5b5/rgb(181,181,181) is not present.
  border: 1px solid #b5b5b5;
  border-radius: ${tokens.radius.m};
  transition: opacity 0.2s;
  opacity: 0;
  top: -16px;
  position: absolute;
  right: 65px;
`;

export const ErrorLine = styled(Line)`
  background-color: ${tokens.color.bg_danger};
  border-bottom: 1px solid ${tokens.color.ember_300};
  position: relative;

  &:hover {
    background-color: ${tokens.color.ember_200};

    ${ErrorActionMenu} {
      display: block;
      opacity: 1;
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  height: 16px;
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  text-align: left;

  margin-top: -1px;
`;

export const LogText = styled(Text)`
  display: inline-block;
  overflow: hidden;

  // Adding ellipsis for multiline paragraph
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  color: ${tokens.color.text_default};
  text-align: left;

  line-height: 20px;
  max-height: 40px;
  font-size: 12px;
  white-space: break-spaces;

  font-family: monospace, sans-serif;

  margin-left: ${tokens.spacer.x1};
`;

export const ErrorText = styled(LogText)<{ clickable: boolean }>`
  color: ${tokens.color.danger_cta_alt};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};
`;

export const ErrorStack = styled.table`
  margin-top: ${tokens.spacer.x0pt5};

  font-size: 12px;
  font-family: monospace, sans-serif;

  border-spacing: ${tokens.spacer.x1};
  border-collapse: separate;
`;

export const StackRow = styled.tr`
  margin-bottom: ${tokens.spacer.x1};
  table-layout: fixed;
`;

export const TimeButton = styled.button`
  background: none;
  border: none;
  padding: 0;

  display: flex;

  margin-left: ${tokens.spacer.x1};

  color: ${tokens.color.text_light};

  line-height: 20px;
  font-size: 12px;

  font-family: monospace, sans-serif;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const DropdownButton = styled.button<{ isOpen: boolean }>`
  background: none;
  border: none;
  padding: 0;

  height: 16px;
  transform: ${({ isOpen }) => (isOpen ? 'none' : 'rotate(-90deg)')};
  margin-left: ${tokens.spacer.x1};

  cursor: pointer;
`;
